export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_SESSION_ID = 'SET_SESSION_ID';
export const SET_CONFIG_DATA = 'SET_CONFIG_DATA';
export const SET_SDK_PARAMS = 'SET_SDK_PARAMS';
export const SET_CUSTOM_STYLES = 'SET_CUSTOM_STYLES';
export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const SET_IS_PREVIEW = 'SET_IS_PREVIEW';
export const SET_PREVIEW_CONFIG = 'SET_PREVIEW_CONFIG';
export const CLOSE_IFRAME = 'CLOSE_IFRAME';
export const SET_IS_DEMO = 'SET_IS_DEMO';

export const SHOW_MODAL = 'SHOW_MODAL';
export const UPDATE_MODAL_PRIMARY_BUTTON_PROPS = 'UPDATE_MODAL_PRIMARY_BUTTON_PROPS';
export const UPDATE_MODAL_SECONDARY_BUTTON_PROPS = 'UPDATE_MODAL_SECONDARY_BUTTON_PROPS';
export const UPDATE_MODAL_GENERAL_PROPS = 'UPDATE_MODAL_GENERAL_PROPS';
export const HIDE_MODAL = 'HIDE_MODAL';

export const SET_MERCHANT_DATA = 'SET_MERCHANT_DATA';
export const SET_GEO_DATA = 'SET_GEO_DATA';
export const REQ_STATUSES = {
  IDLE: 'idle',
  PENDING: 'pending',
  RESOLVED: 'resolved',
  REJECTED: 'rejected'
};
export const SET_PAYMENT_ALERT_SHOWN = 'SET_PAYMENT_ALERT_SHOWN';
export const SET_AB_TESTING = 'SET_AB_TESTING';
export const SET_PAGE_TOKEN = 'SET_PAGE_TOKEN';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const SET_PAGE_TYPE = 'SET_PAGE_TYPE';
export const SET_USER_FIRST_PAGE_URL = 'SET_USER_FIRST_PAGE_URL';
export const SHOW_BANNER = 'SHOW_BANNER';
export const HIDE_BANNER = 'HIDE_BANNER';
export const SET_COMMON_PAGE_DATA = 'SET_COMMON_PAGE_DATA';

export const GET_PMT_BY_BIN_START = 'GET_PMT_BY_BIN_START';
export const GET_PMT_BY_BIN_SUCCESS = 'GET_PMT_BY_BIN_SUCCESS';
export const GET_PMT_BY_BIN_FAIL = 'GET_PMT_BY_BIN_FAIL';
